import IconsContact from "./IconsContact";
import Nav from "./Nav";

export default function Contact() {
    return (
        <>
            <Nav />
            <section className="contact">
                <h1>Contactez-moi</h1>
                <div className="sousContact">
                    <IconsContact iconContact="fa-regular fa-envelope" subEmail="Me contacter" email="b.laghmam01" lasEmail="@gmail.com" linkeSoc="mailto:b.laghmam01@gmail.com" />
                    <IconsContact iconContact="fa-regular fa-envelope" subEmail="Me contacter" email="contact" lasEmail="@laghmam.com" linkeSoc="mailto:contact@laghmam.com" />
                    <IconsContact iconContact="fa-solid fa-phone" subEmail="Appeler" email="+212623948044" linkeSoc="phone:+212623948044" />
                    {/* <IconsContact iconContact="fa-solid fa-location-dot" subEmail="Berkane" email="Morocco" /> */}
                </div>
                <div className="sociels">
                    <IconsContact linkeSoc="https://www.linkedin.com/in/bilal-laghmam-3b4720202/" iconContact="fa-brands fa-linkedin-in" />
                    <IconsContact linkeSoc="https://github.com/BILAL-LAGHMAM" iconContact="fa-brands fa-github" />
                </div>
            </section>
        </>
    );
}